import React      from 'react';
import ReactDom   from 'react-dom';

import Const      from 'fw_const';
import Utils      from 'utils';

import ReactWordcloud   from 'react-wordcloud';

import { PieChart, Pie, Cell, Legend } from 'recharts';

// -------------------------------------------------------


class ProfilingEazyGender extends React.Component {
  render() {
    let profiling = this.props.profiling;
    
    let data = [
      { name: '女性比率', value: profiling.woman_per },
      { name: '男性比率', value: profiling.man_per },
    ];
    
    let colors = [
      '#B95783',
      '#3B4150',
    ];
    
    let man_strong   = (profiling.man_per > profiling.woman_per) ? 'man-strong' : '';
    let woman_strong = (profiling.man_per < profiling.woman_per) ? 'woman-strong' : '';
    
    return (
      <div className="eazy-gender">
        
        <h5><b>{this.props.title}</b></h5>
        
        <div className="gender-percent">
          
          { (this.props.mode == 'graph')
            ? <div className="pie-chart">
                <PieChart width={180} height={180}>
                  <Pie dataKey="value" data={data} isAnimationActive={false} startAngle={90} endAngle={-270}>
                    { data.map((entry, index) => <Cell key={index} fill={colors[index % colors.length]}/>) }
                  </Pie>
                </PieChart>
              </div>
            : <div className="bar-chart">
                <p className="bar man-bar" style={{ width: profiling.man_per + '%' }} />
                <p className="bar woman-bar" style={{ width: profiling.woman_per + '%' }} />
              </div>
          }
          
          <div className="gender-percent-box">
            <p className="man_icon" />
            <p className={'per man '+ man_strong}>{profiling.man_per}%</p>
            
            <p className="woman_icon" />
            <p className={'per woman '+ woman_strong}>{profiling.woman_per}%</p>
          </div>
        </div>
        
      </div>
    );
  }
}
// -------------------------------------------------------

// レンダリング処理
export default ProfilingEazyGender;